import { FEATURES, RMM } from "./data";
import { Section, BrowserFrame } from "./ui";

const Card = ({ f }) => (
  <div className={`group rounded-2xl border border-slate-800 bg-slate-900/40 p-6 transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-sky-500/40 ${f.wide ? "lg:col-span-2" : ""}`}>
    <f.icon className="h-6 w-6 text-sky-400 mb-4" />
    <h3 className="font-bold text-lg mb-2">{f.title}</h3>
    <p className="text-sm text-slate-400 leading-relaxed">{f.text}</p>
  </div>
);

export const Features = () => (
  <Section id="fonctionnalites" over="PRISE EN MAIN À DISTANCE" title="Tout ce qu'il faut pour dépanner, sans vous déplacer"
    lead="Vos postes apparaissent en ligne en temps réel. Un clic et vous êtes devant l'écran de l'utilisateur, avec la voix, le chat et les fichiers.">
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 lg:grid-flow-dense gap-4">{FEATURES.map((f) => <Card key={f.title} f={f} />)}</div>
  </Section>
);

export const RmmSection = () => (
  <Section id="rmm" className="bg-[#0B1120]" over="SUPERVISION DU PARC (RMM)" title="Voyez les problèmes avant vos utilisateurs"
    lead="ScreenView surveille chaque poste et vous laisse décider : mises à jour, logiciels, alertes et rapports, sans module en option.">
    <div className="grid lg:grid-cols-[1.2fr_1fr] gap-10 items-start">
      <BrowserFrame src="/landing/rmm.jpg" alt="Tableau de supervision du parc ScreenView" />
      <div className="grid sm:grid-cols-2 gap-x-6 gap-y-7">
        {RMM.map((r) => (
          <div key={r.title} data-testid={`rmm-feature-${r.title}`}>
            <r.icon className="h-5 w-5 text-sky-400 mb-2" />
            <p className="font-semibold mb-1">{r.title}</p>
            <p className="text-sm text-slate-400 leading-relaxed">{r.text}</p>
          </div>
        ))}
      </div>
    </div>
  </Section>
);
